import { bindActionCreators } from 'redux'
import { connect, useSelector } from 'react-redux'
import { useActions } from 'react-redux-actions-hook'
import { createStructuredSelector } from 'reselect'

import {
  actionCreators,
  abortSearch,
  submitFilter,
  loadFilters,
  saveFilters,
} from '@/checkout-instore-legacy/search/actions'
import { setCustomer } from '@/checkout-instore-legacy/order/actions'
import { updateCartAddressWithSimulationAddress } from '@/checkout-instore-legacy/cart/simulation/actions'

import SearchPage from '../../components/SearchPage'

import {
  termSearchSelector,
  pageSearchSelector,
  resultsSearchSelector,
  nextResultsSearchSelector,
  recentTermsSearchSelector,
  intervalBeginSearchSelector,
  loadingSearchSelector,
  errosSearchSelector,
  nextLoadingSearchSelector,
  loadingProductsSelector,
  filtersSearchSelector,
} from '../selectors'

import { clientProfileSelector } from '@/checkout-instore-legacy/order/selectors'
import { logisticsInfoCacheSelector } from '@/checkout-instore-legacy/cart/simulation/selectors'

export const mapStateToPropsSelector = createStructuredSelector({
  term: termSearchSelector,
  page: pageSearchSelector,
  results: resultsSearchSelector,
  nextResults: nextResultsSearchSelector,
  recentTerms: recentTermsSearchSelector,
  intervalBegin: intervalBeginSearchSelector,
  loading: loadingSearchSelector,
  errors: errosSearchSelector,
  nextLoading: nextLoadingSearchSelector,
  loadingProducts: loadingProductsSelector,
  clientProfileData: clientProfileSelector,
  logisticsInfoCache: logisticsInfoCacheSelector,
  filters: filtersSearchSelector,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ...actionCreators,
      setCustomer,
      abortSearch,
      updateCartAddressWithSimulationAddress,
      submitFilter,
      reloadFilters: loadFilters,
    },
    dispatch
  )

export default connect(mapStateToPropsSelector, mapDispatchToProps, undefined, {
  pure: false,
})(SearchPage)

export const useSearchSharedValue = () => useSelector(mapStateToPropsSelector)

export const useSearchSharedAction = () => {
  const actions = useActions(
    {
      submitFilter,
      saveFilters,
    },
    []
  )

  return actions
}
